import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { motion } from "framer-motion";
import banner from "../../assets/images/blog_details.png";
import {
  ArrowLeft,
  Clock,
  Calendar,
  Share2,
  CheckCircle2,
  Terminal,
  ChevronRight,
  ArrowUpRight,
} from "lucide-react";
import blogs from "../data/blogsdata";
import ShareModal from "../Addons/ShareModal";
export default function BlogDetail() {
  const params = useParams();
  const [blogData, setBlogData] = useState();
  // const [filterBlogs, setFilterBlogs] = useState([]);
  const [shareOpen, setShareOpen] = useState(false);
  const slug = params.slug;
  useEffect(() => {
    try {
      // const filteredData = blogs.filter((f) => f.slug !== slug).slice(0, 4);
      const data = blogs.find((u) => u.slug === slug);
      setBlogData(data);
      // setFilterBlogs(filteredData);
    } catch (error) {
      console.log(error);
    }
  }, [slug]);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <>
      <article className="relative w-full bg-[#F8FAFC] min-h-screen text-slate-900 font-sans selection:bg-[#5dc9f0]/30">
        <header className="relative w-full bg-white text-white[#000036] py-48 pb-20 px-6 sm:px-8 lg:px-12  ">
          <div
            className="pointer-events-none absolute top-0 left-0 w-full h-full opacity-20 "
            style={{
              background:
                "linear-gradient(135deg, #62d4f7 0%, #5dc9f0 40%, #3579be 60%",
            }}
          />
          <div className="pointer-events-none absolute  bottom-0 left-5 max-w-[50%] lg:max-w-[40%] h-auto select-none">
            <img
              src={banner}
              alt=""
              className="w-full h-full opacity-20 object-contain object-right-top"
            />
          </div>
          <div className="max-w-4xl mx-auto text-center relative z-10 pt-5 space-y-8">
            <div className="space-y-4">
              <motion.h1
                initial={{ opacity: 0, y: 15 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
                className="sm:text-3xl md:text-4xl  text-2xl font-extrabold tracking-tight text-[#000036] leading-tight font-display"
              >
                {blogData?.title}
              </motion.h1>
              <motion.p
                initial={{ opacity: 0, y: 15 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.1 }}
                className="text-base sm:text-lg text-slate-600 font-normal leading-relaxed"
              >
                {blogData?.subtitle}
              </motion.p>
            </div>
            <div className="md:flex hidden flex-wrap items-center justify-center gap-6 pt-6 border-t border-white/10 text-xs font-mono text-slate-400"></div>
          </div>
        </header>
        <main className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-16 relative z-10">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-start">
            <aside className="lg:col-span-4 space-y-6 lg:sticky lg:top-28">
              <div className="flex flex-wrap items-center justify-start ps-1.5 gap-4">
                <Link
                  to="/blogs"
                  className="inline-flex items-center gap-2 text-xs font-mono font-bold uppercase tracking-wider text-[#000036] hover:text-[#5dc9f0] transition-colors"
                >
                  <ArrowLeft size={14} />
                  <span>Back to all Blogs</span>
                </Link>
              </div>
              <div className="rounded-2xl bg-white border border-slate-200/90 p-6 shadow-sm space-y-4">
                <span className="text-sm  tracking-widest text-slate-400 font-bold block">
                  Benchmark Telemetry
                </span>
                <div className="grid grid-cols-1 divide-y divide-slate-100">
                  {blogData?.metrics.map((m, i) => (
                    <div
                      key={i}
                      className="py-3 first:pt-0 last:pb-0 flex items-center justify-between"
                    >
                      <span className="text-sm text-slate-500 font-medium">
                        {m.label}
                      </span>
                      <span className=" text-sm font-serif font-bold text-[#000036]">
                        {m.value}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
              <div className="rounded-2xl bg-white border border-slate-200/90 p-6 shadow-sm space-y-4">
                <span className="text-sm tracking-widest text-slate-400 font-bold block">
                  Table of Content
                </span>
                <nav className="space-y-2">
                  {blogData?.tableOfContents.map((item) => (
                    <a
                      key={item.id}
                      href={`#${item.id}`}
                      className="block text-sm font-medium text-slate-600 hover:text-[#000036] hover:translate-x-1 transition-all py-1"
                    >
                      {item.title}
                    </a>
                  ))}
                </nav>
              </div>
                <button
                  onClick={() => setShareOpen(true)}
                  className="w-full flex items-center justify-between px-5 py-4 rounded-2xl bg-[#EAF7FC] border border-[#C9EDF8] text-[#000036] hover:bg-[#DDF3FA] transition-colors"
                >
                  <span className="flex items-center gap-2 text-xs font-bold uppercase tracking-wider">
                    <Share2 size={16} />
                    Share Case Study
                  </span>
                  <ArrowUpRight size={16} />
                </button> 
            </aside>
            <div className="lg:col-span-8 space-y-6">
              <div className="flex flex-wrap items-center justify-between gap-4">
                <span className=" text-sm font-bold uppercase  text-[#000036]  px-3">
                  {blogData?.tag}
                </span>
                <div className="flex items-center text-sm px-3 gap-4 font-semibold">
                  <span className="flex items-center gap-1.5">
                    <Calendar size={18} className="text-[#000036]" />
                    {blogData?.date}
                  </span>
                  <span className="flex items-center gap-1.5">
                    <Clock size={18} className="text-[#000036]" />
                    {blogData?.readTime}
                  </span>
                </div>
              </div>
              <div className="relative w-full h-56 sm:h-96 rounded-xl overflow-hidden bg-slate-100 border border-slate-200/80">
                <img
                  src={blogData?.image}
                  alt={blogData?.title}
                  className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500 ease-out"
                />
              </div>
              <div className="p-7 rounded-2xl bg-[#000036] text-white space-y-3 shadow-md border border-slate-800">
                <p className="text-base text-slate-200 leading-relaxed font-normal">
                  {blogData?.content?.keyTakeaway}
                </p>
              </div>
              <p className="text-lg text-slate-700 leading-relaxed font-normal">
                {blogData?.content?.intro}
              </p>
              {blogData?.content?.sections.map((section) => (
                <section
                  key={section.id}
                  id={section.id}
                  className="space-y-5 pt-4 scroll-mt-28"
                >
                  <h2 className="text-2xl sm:text-3xl font-bold tracking-tight text-[#000036]">
                    {section.heading}
                  </h2>
                  {section.body.map((para, pIdx) => (
                    <p
                      key={pIdx}
                      className="text-base text-slate-600 leading-relaxed font-normal"
                    >
                      {para}
                    </p>
                  ))}
                  {section.codeSnippet && (
                    <div className="my-6 rounded-2xl bg-slate-950 border border-slate-800 overflow-hidden shadow-xl">
                      <div className="flex items-center justify-between px-5 py-3 border-b border-slate-800 bg-slate-900/70 text-xs font-mono text-slate-400">
                        <div className="flex items-center gap-2">
                          <Terminal size={14} className="text-[#5dc9f0]" />
                          <span>{section?.codeSnippet?.title}</span>
                        </div>
                        <span className="text-[10px] uppercase font-bold text-slate-500">
                          {section?.codeSnippet?.language}
                        </span>
                      </div>
                      <pre className="p-5 text-xs sm:text-sm font-mono text-sky-200 overflow-x-auto leading-relaxed">
                        <code>{section?.codeSnippet?.code}</code>
                      </pre>
                    </div>
                  )}
                  {section.bulletPoints && (
                    <div className="space-y-3 pt-2">
                      {section.bulletPoints.map((point, bIdx) => (
                        <div
                          key={bIdx}
                          className="flex items-start gap-3 p-3.5 rounded-xl bg-white border border-slate-200/80 shadow-xs text-sm text-slate-700 font-medium"
                        >
                          <CheckCircle2
                            size={16}
                            className="text-[#5dc9f0] shrink-0 mt-0.5"
                          />
                          <span>{point}</span>
                        </div>
                      ))}
                    </div>
                  )}
                </section>
              ))}
              <div className="mt-16 pt-8 border-t border-slate-200 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
                <div className="flex items-center gap-4">
                  <img
                    src={blogData?.author?.avatar}
                    alt={blogData?.author?.name}
                    className="w-12 h-12 rounded-full object-cover border border-slate-300"
                  />
                  <div>
                    <h4 className="font-bold text-slate-900 text-sm">
                      {blogData?.author?.name}
                    </h4>
                    <p className="text-xs text-slate-500">
                      {blogData?.author?.role}
                    </p>
                  </div>
                </div>
                <Link
                  to="/contact"
                  className="group inline-flex items-center gap-3 px-6 py-3 rounded-full bg-[#000036] text-white text-xs font-mono font-bold uppercase tracking-wider hover:bg-slate-900 transition-colors"
                >
                  <span>Discuss Architecture</span>
                  <ChevronRight
                    size={14}
                    className="group-hover:translate-x-1 transition-transform"
                  />
                </Link>
              </div>
            </div>
          </div>
        </main>
      </article>
      <ShareModal isOpen={shareOpen}
        onClose={() => setShareOpen(false)}
        url={window.location.href}
        title={blogData?.title}
        description={blogData?.summary} />
    </>
  );
}
